<template>
  <div class="rate-table">
    <el-scrollbar class="scrollbar-y-hidden">
      <el-table style="width: 99%" :data="list" border>
        <el-table-column
          label="序号"
          prop="index"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column label="投标单位" align="center" min-width="200px">
          <template v-slot:default="{ row }">
            <span v-if="quoteReviewOpened">{{ row.supplierName }}</span>
            <el-select
              v-else
              v-model="row.supplierId"
              filterable
              placeholder="请选择"
              @change="onSupplierSelectChange"
            >
              <el-option
                v-for="item in optionList"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
                :disabled="itemDisabled(item)"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="设置企业折扣率"
          align="center"
          min-width="120px"
        >
          <template slot-scope="{ row }">
            <span v-if="quoteReviewOpened">{{ row.offerRate }}%</span>
            <el-input
              v-else
              v-model="row.offerRate"
              placeholder="请输入"
              @input="changeInput(row)"
            >
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column v-if="!quoteReviewOpened" label="操作" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="removeRow(row, $index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>
    <div
      v-if="showTableAction"
      class="table-footer__operation p-t-6 p-b-6 m-t-16"
      @click="addRow"
    >
      <a-icon type="plus" />
      <span>添加企业</span>
    </div>
  </div>
</template>

<script>
import { purchaseTypeDict } from '@/dictionary/project/common'
import { getInquiryReviewScorePageApi } from '@/api/procure/inquiry-review'
import { getNegotiationReviewScorePageApi } from '@/api/procure/negotiation-review'
import { getPurchaseReviewSupplierQuoteListApi } from '@/api/procure/purchase-review'

/**
 * 企业折扣率
 */
export default {
  name: 'OnlineReviewQuoteRateTable',

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    // 当前的评审办法id
    wayId: {
      type: [String, Number],
      default: ''
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    // 价格分评审是否已开启，开启后不能设置折扣率
    quoteReviewOpened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,

      bidderList: [],
      optionList: [],

      list: []
    }
  },

  computed: {
    getReviewScorePageApi() {
      const objApi = {
        [purchaseTypeDict.INQUIRY.value]: getInquiryReviewScorePageApi,
        [purchaseTypeDict.NEGOTIATION.value]: getNegotiationReviewScorePageApi
      }
      return objApi[this.purchaseType]
    },

    showTableAction() {
      return (
        !this.quoteReviewOpened && this.list.length < this.bidderList.length
      )
    }
  },

  watch: {
    list: {
      handler(val) {
        this.$emit('getList', val)
      },
      deep: true
    }
  },

  created() {
    if (!this.quoteReviewOpened) {
      this.getBidderList()
    }
    this.getQuoteRateList()
  },

  beforeDestroy() {
    this.list = []
  },

  methods: {
    changeInput(row) {
      const pattern = /^[1-9][0-9]*$/
      if (!pattern.test(row.offerRate) || Number(row.offerRate) > 100) {
        row.offerRate = ''
      }
    },

    addRow() {
      const row = {
        // 投标单位id
        supplierId: '',
        // 投标单位名称
        supplierName: '',
        // 折扣率
        offerRate: ''
      }
      this.list.push(row)
    },

    removeRow(row, index) {
      this.list.splice(index, 1)
    },

    getBidderList() {
      const params = {
        isListing: 1,
        orderId: this.orderId,
        wayId: this.wayId
      }
      this.getReviewScorePageApi(this.reviewId, params)
        .then(res => {
          this.bidderList = res.data?.records || []
          this.optionList = this.bidderList
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    getQuoteRateList() {
      getPurchaseReviewSupplierQuoteListApi(this.reviewId)
        .then(res => {
          this.list = res.data || []
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    itemDisabled(item) {
      return (
        this.list.findIndex(
          listItem => listItem.supplierId === item.supplierId
        ) > -1
      )
    },

    onSupplierSelectChange() {
      this.list.forEach(item => {
        const supplierItem = this.bidderList.find(
          bidder => bidder.supplierId === item.supplierId
        )
        item.supplierName = supplierItem.supplierName
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rate-table {
  height: 100%;
  background: $white-color;
  display: flex;
  flex-direction: column;
}
.table-footer__operation {
  width: 100%;
  border: 1px dashed #d9d9d9;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
}
</style>
